import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f239630"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-info alert-dismissible fade show",
  role: "alert"
}
const _hoisted_3 = { class: "alert-heading" }
const _hoisted_4 = {
  key: 1,
  class: "alert alert-success alert-dismissible fade show",
  role: "alert"
}
const _hoisted_5 = { class: "alert-heading" }
const _hoisted_6 = {
  key: 2,
  class: "alert alert-warning alert-dismissible fade show",
  role: "alert"
}
const _hoisted_7 = { class: "alert-heading" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 3,
  class: "alert alert-danger alert-dismissible fade show",
  role: "alert"
}
const _hoisted_10 = { class: "alert-heading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.check('info'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.check('info'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn-close",
                "aria-label": "Close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fecha('info')))
              }))
            : _createCommentVNode("", true),
          _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.infoTitle()), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.infoText()), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.check('success'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "aria-label": "Close",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fecha('success')))
          }),
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.successTitle()), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.successText()), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.check('warning'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "aria-label": "Close",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel('warning')))
          }),
          _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.warningTitle()), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.warningText()), 1),
          (_ctx.isWarningConfirmation())
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Confirm",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirm('warning')))
                }, " Confirm "),
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Cancel",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancel('warning')))
                }, " Cancel ")
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.check('danger'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "aria-label": "Close",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.fecha('danger')))
          }),
          _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.dangerTitle()), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.dangerText()), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}